/**
 * Created by han on 11/27/2018.
 */

/*
<a data-anchor="top" href="#"></a> by '#' in href - to top
<a data-anchor="#id" href="#"></a> by '#id' in href - to block with id
<a data-anchor="#id" href="some-page.html"></a> by 'some-page.html/#id' in href - to block with id on another
*/

import $ from '../util/dom';

class Anchor {

	constructor(window, document) {
		this.window = window;
		this.document = document;
	}

	init() {
		this.root = $('html, body');
		$( this.document ).on('click', e => {
			let t = $(e.target).closest('[data-anchor]');
			if ( t.length > 0 ) {
				e.preventDefault();
				this.clickHandler(t);
			}
		});
	}

	clickHandler(t) {
		const data = t.attr('data-anchor');

		if (data === 'top') {
			this.root.scrollTo(0, 0, 800);
		} else if ( /^#/.test(data) ) {
			let tId = $(data);
			if (tId.length === 1) {
				this.root.scrollTo(0, tId.offset().top + window.pageYOffset, 800);
			} else {
				let href = t.attr('href');
				localStorage.setItem('anchorId', data);
				this.window.location.replace(href);
			}
		}
	}

	loadHandler() {
		const ls = localStorage;
		const hash = ls.getItem('anchorId');

		if ( !hash ) return;
		ls.removeItem('anchorId');
		const tId = $(hash);

		if (tId.length < 1) return;
		setTimeout(() => {
			this.root.scrollTo(0, tId.offset().top + window.pageYOffset, 800);
		}, 300);
	}
}

const anchor = new Anchor(window, document);

export default {
	name: 'Anchor',
	Anchor: anchor,
	on: {
		'interactive': function () {
			this.Anchor.init();
		},
		'endPreloadAnimation': function () {
			this.Anchor.loadHandler();
		}
	},
};